import axios from "axios";
import { AppConfig } from "../config";

export async function GetAvailability() {
  const resp = await axios.get(AppConfig.api + "/");

  return resp.data.status as "available" | "away";
}
